import React from "react";
import { View, StyleSheet, StyleProp, ViewStyle, LayoutChangeEvent } from "react-native";
import { useTheme } from "@/hooks/useTheme";

interface ModernCardProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  padding?: number;
  margin?: number;
  shadow?: "none" | "small" | "medium" | "large";
  onLayout?: (event: LayoutChangeEvent) => void;
}

export function ModernCard({
  children,
  style,
  padding = 20,
  margin = 16,
  shadow = "medium",
  onLayout,
}: ModernCardProps) {
  const { colors } = useTheme();

  const shadowStyles = {
    none: {},
    small: {
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
      elevation: 2,
    },
    medium: {
      boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.15)",
      elevation: 4,
    },
    large: {
      boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
      elevation: 8,
    },
  };

  return (
    <View
      onLayout={onLayout}
      style={[
        styles.card,
        {
          backgroundColor: colors.card,
          borderColor: colors.border,
          padding,
          margin,
        },
        shadowStyles[shadow],
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 16,
    borderWidth: StyleSheet.hairlineWidth,
  },
});
